export default class FormCheckItem {
    public name: string = "";
    
    public ok: boolean | null = null;
    
    public isRequired: boolean = true;

    public isFormCheckItem: boolean = true;
}